





















import { defineComponent, computed, ref } from "@vue/composition-api";
import { injectStrict } from "@/lib/utils";
import { RubricStoreKey } from "@/store/StoreInjectionKeys";

export default defineComponent({
  setup(props) {
    const rubricStore = injectStrict(RubricStoreKey);
    const display = ref('description')

    const toggle = () => {
      display.value = display.value == 'description' ? 'critical attributes' : 'description'
    }
    return {
       rubricStore,
       display,
       toggle
    }
  },
  methods: {
    performanceLevelText(pl: number) {
      switch (pl) {
        case 0:
          return "Unsatisfactory";
        case 1:
          return "Progressing";
        case 2:
          return "Effective";
        case 3:
          return "Highly Effective";
      }
    }
  },
  props: {
    item: {
      type: Object,
      required: true
    }
  }
});
